import React from "react";
import { Modal, Button, Input, Icon, Popconfirm } from "antd";
import config from "appConfig";
import styles from "./styles/agency.scss";
import { formatDate, notification } from "../../../services";

// Public link (served by the frontend BFF) that returns the agency's active ad URLs as a JSON array
const buildFeedLink = secret =>
  `${window.location.origin}${config.baseFolder}/services/agency-ads/${secret}.json`;

const AgencyFeedModal = props => {
  const { agency, visible, loading, onClose, onGenerate, onRevoke } = props;

  if (!agency) {
    return null;
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(buildFeedLink(agency.feedSecret));
    notification.show("Link kopiran");
  };

  const renderContent = () => {
    if (!agency.feedSecret) {
      return (
        <React.Fragment>
          <p>{"Agencija nema generiran ključ za feed aktivnih oglasa."}</p>
          <Button type="primary" loading={loading} onClick={() => onGenerate(agency)}>
            <Icon type="key" />
            {"Generiraj ključ"}
          </Button>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <p>{"Link za dohvat URL-ova aktivnih oglasa (JSON):"}</p>
        <Input
          readOnly
          value={buildFeedLink(agency.feedSecret)}
          className={styles.feedInput}
          onClick={handleCopy}
          addonAfter={
            <Icon type="copy" style={{ cursor: "pointer" }} onClick={handleCopy} />
          }
        />
        <p className={styles.feedStats}>
          {"Broj zahtjeva: "}
          <strong>{agency.feedRequestCount || 0}</strong>
          {" · Zadnji zahtjev: "}
          <strong>
            {agency.feedLastRequestDate
              ? formatDate(agency.feedLastRequestDate, config.longTimeFormat)
              : "–"}
          </strong>
        </p>
        <Popconfirm
          title={"Sigurno opozvati ključ? Postojeći link odmah prestaje raditi."}
          onConfirm={() => onRevoke(agency)}
          okText={"Da"}
          cancelText={"Ne"}
        >
          <Button type="danger" loading={loading}>
            <Icon type="stop" />
            {"Opozovi ključ"}
          </Button>
        </Popconfirm>
      </React.Fragment>
    );
  };

  return (
    <Modal
      title={`Feed aktivnih oglasa – ${agency.username}`}
      visible={visible}
      centered
      onCancel={onClose}
      footer={<Button onClick={onClose}>{"Zatvori"}</Button>}
    >
      {renderContent()}
    </Modal>
  );
};

export default AgencyFeedModal;



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAgencyPage/AgencyFeedModal.tsx